/**
 * EncounterSlice Edit Tracking Reducers
 * 
 * Reducers for managing edit state and dirty tracking.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { EncounterSliceState } from '../state';
import { addEditedField } from '../../../shared/sliceUtils';

// =============================================================================
// EDIT TRACKING REDUCERS
// =============================================================================

/**
 * Mark a specific field as edited
 */
export const markFieldAsEdited: CaseReducer<EncounterSliceState, PayloadAction<string>> = (
  state,
  action
) => {
  addEditedField(state, action.payload);
};

/**
 * Clear all edited fields tracking
 */
export const clearEditedFields: CaseReducer<EncounterSliceState> = (state) => {
  state.editedFields = [];
  state.isEdited = false;
};

/**
 * Mark as saved - clears edit tracking
 */
export const markAsSaved: CaseReducer<EncounterSliceState> = (state) => {
  state.isEdited = false;
  state.editedFields = [];
};

/**
 * Discard changes - clears edit tracking (UI should refetch from API)
 */
export const discardChanges: CaseReducer<EncounterSliceState> = (state) => {
  state.isEdited = false;
  state.editedFields = [];
};

// =============================================================================
// VALIDATION REDUCERS
// =============================================================================

/**
 * Set a validation error for a specific field
 */
export const setValidationError: CaseReducer<
  EncounterSliceState,
  PayloadAction<{ field: string; message: string }>
> = (state, action) => {
  state.validationErrors[action.payload.field] = action.payload.message;
};

/**
 * Clear a validation error for a specific field
 */
export const clearValidationError: CaseReducer<EncounterSliceState, PayloadAction<string>> = (
  state,
  action
) => {
  delete state.validationErrors[action.payload];
};

/**
 * Clear all validation errors
 */
export const clearAllValidationErrors: CaseReducer<EncounterSliceState> = (state) => {
  state.validationErrors = {};
};
